// Footer component
import React from "react";
import '../../styles/shared/Footer.css'
import WhatsAppButton from './WhatsAppButton';

function Footer (){
    const currentYear = new Date().getFullYear();
    const startYear = 2021;

    return (
        <>
            <div className="footer-component">
                <div className="footer">
                    <div className="footer-content">
                        {/* Socials links */}
                        <div className="footer-socials-links">
                            <a href="https://www.facebook.com/share/18b29zaizi/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                                <img className="facebook-link" src="/images/facebook.png" alt="Facebook-icon" />
                            </a>
                            <a href="https://x.com/__kinda_?s=11&t=dj9QV_j076ekCceMsMF0XQ" target="_blank" rel="noopener noreferrer">
                                <img className="x-link" src="/images/twitter.png" alt="x-icon" />
                            </a>
                            <a href="https://www.instagram.com/__.kinda_/" target="_blank" rel="noopener noreferrer">
                                <img className="instagram-link" src="/images/instagram.png" alt="Instagram-icon" />
                            </a>
                            <a href="https://www.tiktok.com/@__kinda._?_t=ZM-8t8VxoUt13V&_r=1" target="_blank" rel="noopener noreferrer">
                                <img className="tiktok-link" src="/images/tik-tok.png" alt="Tiktok-icon" />
                            </a>
                            <a href="https://www.linkedin.com/company/signifide-group-international/" target="_blank" rel="noopener noreferrer">
                                <img className="linkedin-link" src="/images/linkedin.png" alt="LinkedIn-icon" />
                            </a>
                        </div>

                        {/* Company logo and contact info */}
                        <div className="footer-info">
                            <div className="footer-info-1">
                                <div className="sgi-logo">
                                    <img className="footer-logo" src="/images/Signified-logo-Jos-Font-2048x874.png" alt="Signifide Group International logo" />
                                </div>
                            </div>
                            <div className="footer-info-2">
                                <div className="footer-contact-phone">
                                    <img src="/images/telephone.png" alt="phone-icon" />
                                    <p>Landline: +254703785199</p>
                                </div>
                                <a href="mailto:admin@signifide.group" name="footer-contact-email" className="footer-email">
                                    <img src="/images/email.png" alt="email-icon" />
                                    <p>admin@signifide.group</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="footer-copyright">© {currentYear > startYear ? `${currentYear}` : ""} Signifide Group International. All rights reserved.</div>
                </div>
            </div>
            <WhatsAppButton />
        </>
    )
}

export default Footer;